const rankingItems = [
  {
    rank: 1,
    title: '完结漫画热度榜 · 苍穹之刃',
    desc: '热血战斗完结漫画人气冠军，全328话漫画完整版已全部收录。',
    stat: '本周热度 12.8万',
    tag: '热血',
    icon: 'ri-fire-line',
    color: 'text-accent-500',
  },
  {
    rank: 2,
    title: '完结漫画口碑榜 · 樱花树下',
    desc: '恋爱甜宠类完结漫画口碑第一，读者评分高达9.6分的漫画全集。',
    stat: '读者评分 9.6',
    tag: '恋爱',
    icon: 'ri-heart-line',
    color: 'text-primary-500',
  },
  {
    rank: 3,
    title: '完结漫画收藏榜 · 暗夜追踪',
    desc: '悬疑推理完结漫画收藏量冠军，结局反转令人拍案叫绝的漫画完整版。',
    stat: '收藏量 9.5万',
    tag: '悬疑',
    icon: 'ri-bookmark-line',
    color: 'text-secondary-500',
  },
  {
    rank: 4,
    title: '完结漫画新作榜 · 异界事务所',
    desc: '最新完结异世界冒险漫画，上线即登顶新作榜首的漫画全集推荐。',
    stat: '本月新增 3.2万阅读',
    tag: '异世界',
    icon: 'ri-rocket-line',
    color: 'text-accent-400',
  },
  {
    rank: 5,
    title: '完结漫画口碑榜 · 日常小确幸',
    desc: '日常治愈类完结漫画好评率最高，温暖无数读者心灵的漫画完整版。',
    stat: '好评率 98.7%',
    tag: '日常',
    icon: 'ri-thumb-up-line',
    color: 'text-primary-400',
  },
];

const rankIconColors = ['text-accent-500', 'text-primary-500', 'text-secondary-500', 'text-foreground-400', 'text-foreground-400'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            完结漫画风云榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            热度、口碑、收藏多维榜单，帮你发现最值得补的完结漫画
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 rounded-xl mb-3 bg-background-100 border border-background-200/60 transition-all duration-200 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg font-bold ${rankIconColors[i]} bg-background-50 shrink-0`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-primary-100/70 text-primary-600 text-xs font-medium shrink-0 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
              <div className="shrink-0 text-right">
                <div className="flex items-center gap-1 justify-end">
                  <i className={`${item.icon} text-sm ${item.color}`}></i>
                  <span className="text-xs font-semibold text-foreground-700 whitespace-nowrap">{item.stat}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}